import { format } from 'date-fns';
import { DATE_DD_MON_YEAR } from 'constants/dateFormat';
import { JOB_ANY_DATE, JOB_VALUE_ALL } from '../constants';
import { JobItem } from '../types';

export type FilterJobHelperOptions = {
  jobsList: JobItem[];
  selectedStarted: string;
  selectedStatus: string;
  selectedType: string;
};

export const filterJobsList = ({
  jobsList,
  selectedStarted,
  selectedStatus,
  selectedType,
}: FilterJobHelperOptions): JobItem[] =>
  jobsList.filter((job) => {
    let result = true;

    if (selectedStarted !== JOB_ANY_DATE) {
      const currStarted = format(new Date(selectedStarted), DATE_DD_MON_YEAR);
      const jobStarted = format(new Date(job.started), DATE_DD_MON_YEAR);

      if (currStarted !== jobStarted) {
        result = false;
      }
    }

    if (selectedStatus !== JOB_VALUE_ALL && job.status !== selectedStatus) {
      result = false;
    }

    if (selectedType !== JOB_VALUE_ALL && job.type !== selectedType) {
      result = false;
    }

    return result;
  });
